import React from 'react';
import PropTypes from 'prop-types';
import { RenderModule } from 'holocron';
import { useHolocronState } from '../hooks/useHolocronState';
import constants from '../utils/constants';

const GlobalNavigationWrapper = ({ children }) => {
  const state = useHolocronState();
  const loadedHolocrons = state.getIn(['holocron', 'loaded']);
  const isGlobalHeaderLoaded = loadedHolocrons.includes('axp-global-header');
  const isGlobalFooterLoaded = loadedHolocrons.includes('axp-footer');

  const isNavNonSticky = constants.nonStickyModules.some((module) => loadedHolocrons.has(module));

  return (
    <>
      {isGlobalHeaderLoaded ? (
        <RenderModule
          props={{
            isNavNonSticky,
          }}
          moduleName="axp-global-header"
        />
      ) : null}

      {children}
      {isGlobalFooterLoaded ? <RenderModule moduleName="axp-footer" /> : null}
    </>
  );
};

GlobalNavigationWrapper.propTypes = {
  children: PropTypes.node,
  route: PropTypes.shape({
    store: PropTypes.shape({
      getState: PropTypes.func,
    }),
  }),
};

GlobalNavigationWrapper.defaultProps = {
  children: null,
};

export default GlobalNavigationWrapper;
